import * as APPCONFIG from "../config/app-config.js";
import api from "./BaseAPI.js";
import auth from "./AuthAPI.js";
import Http from "./Http.js";
class SpecializationService {
  createOrEditSpecialization(formValues) {
    return auth({
      method: "post",
      headers: Http.AUTH_HEADERS(),
      url: `${APPCONFIG.API_URL}auth/category/createOrEdit`,
      data: JSON.stringify(formValues),
    });
  }

  getSpecialization(formValues) {
    return auth({
      method: "post",
      headers: Http.AUTH_HEADERS(),
      url: `${APPCONFIG.API_URL}auth/v1/get-specialization`,
      data: JSON.stringify(formValues),
    });
  }

  getSpecializationForMarkertplace(formValues) {
    return api({
      method: "post",

      url: `${APPCONFIG.API_URL}auth/v1/search-category-serviceMakertplace`,
      data: JSON.stringify(formValues),
    });
  }
}
export default new SpecializationService();
